import { db } from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

const isUserExists = async (authProvider = "email", identity = "") => {
  /**
   * input:
   *  authProvider: email | phone
   * output: bool
   * description: checks if user exists or not
   */

  try {
    identity = identity.replaceAll(" ", "").trim();
    const usersRef = await collection(db, "users");
    const q = query(
      usersRef,
      where(authProvider === "phone" ? "phoneNumber" : "email", "==", identity)
    );
    const usersSnapshot = await getDocs(q);

    return usersSnapshot.docs.length === 0 ? false : true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default isUserExists;
